import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { KeenIcon } from '@/components/keenicons';
import { DatePicker, PriceInput } from '@/components/form';
import { NEGOTIATION_KINDS } from './letterStatus';

const schema = Yup.object().shape({
  kind: Yup.string().required('Required'),
  party: Yup.string().required('Required'),
  amount: Yup.string().nullable(),
  occurred_at: Yup.string().nullable(),
  expires_at: Yup.string().nullable(),
  notes: Yup.string().max(5000).nullable(),
});

/**
 * Log an offer, counter, acceptance, rejection or a call note against a sent
 * demand. Insurer entries update the letter's response summary.
 */
const NegotiationModal = ({ open, onClose, onSubmit, loading = false }) => {
  if (!open) return null;

  return (
    <div className="modal-wrapper modal-animate-fade">
      <Formik
        initialValues={{ kind: 'offer', party: 'insurer', amount: '', occurred_at: '', expires_at: '', notes: '' }}
        validationSchema={schema}
        onSubmit={(values) => onSubmit?.({
          kind: values.kind,
          party: values.party,
          amount: values.amount || null,
          occurred_at: values.occurred_at || null,
          expires_at: values.expires_at || null,
          notes: values.notes || null,
        })}
      >
        {({ values, setFieldValue }) => (
          <Form className="modal-animate-scale modal-body w-4/5 max-w-lg relative">
            <h3 className="card-title mb-5">Log negotiation</h3>
            <button type="button" onClick={onClose} className="modal-close-btn"><KeenIcon icon="cross" /></button>

            <div className="grid grid-cols-2 gap-4 mb-4">
              <div>
                <label className="form-label mb-1">What happened</label>
                <Field
                  as="select"
                  name="kind"
                  className="select"
                  onChange={(e) => {
                    setFieldValue('kind', e.target.value);
                    if (e.target.value === 'offer') setFieldValue('party', 'insurer');
                  }}
                >
                  {NEGOTIATION_KINDS.map((k) => <option key={k.value} value={k.value}>{k.label}</option>)}
                </Field>
              </div>
              <div>
                <label className="form-label mb-1">From</label>
                <Field as="select" name="party" className="select" disabled={values.kind === 'offer'}>
                  <option value="insurer">The insurer</option>
                  <option value="us">Our office</option>
                </Field>
              </div>
            </div>

            <div className="grid grid-cols-3 gap-4 mb-4">
              <div>
                <label className="form-label mb-1">Amount</label>
                <PriceInput name="amount" prefix="$" />
              </div>
              <div>
                <label className="form-label mb-1">Date</label>
                <Field name="occurred_at" component={DatePicker} />
              </div>
              <div>
                <label className="form-label mb-1">Expires</label>
                <Field name="expires_at" component={DatePicker} />
              </div>
            </div>

            <div className="mb-4">
              <label className="form-label mb-1">Notes</label>
              <Field as="textarea" name="notes" rows={3} className="input h-auto py-2" placeholder="Who said what, and any conditions." />
              <ErrorMessage name="notes" component="div" className="text-red-500 text-xs mt-1" />
            </div>

            <div className="flex justify-end gap-2">
              <button type="button" className="btn btn-sm btn-light" onClick={onClose}>Cancel</button>
              <button type="submit" className="btn btn-sm btn-primary" disabled={loading}>{loading ? 'Saving…' : 'Save entry'}</button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export { NegotiationModal };
